import { NewBookingSchema } from "../firestore/Types/NewBookingSchema";
import { TutorScheduleNoTimeZone } from "../firestore/Types/TutorProfileSchema";
import { ItemPair } from "../firestore/Types/UI/ItemPair";

export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const timesHalfAnHour = ["12AM", "12:30AM", "1AM", "1:30AM", "2AM", "2:30AM", "3AM", "3:30AM", "4AM", "4:30AM", "5AM", "5:30AM", "6AM", "6:30AM", "7AM", "7:30AM", "8AM", "8:30AM", "9AM", "9:30AM", "10AM", "10:30AM", "11AM", "11:30AM", "12PM", "12:30PM", "1PM", "1:30PM", "2PM", "2:30PM", "3PM", "3:30PM", "4PM", "4:30PM", "5PM", "5:30PM", "6PM", "6:30PM", "7PM", "7:30PM", "8PM", "8:30PM", "9PM", "9:30PM", "10PM", "10:30PM", "11PM", "11:30PM",];
export const get15minuteIntervals = ["12:00AM", "12:15AM","12:30AM","12:45AM", "1:00AM","1:15AM","1:30AM","1:45AM","2:00AM","2:15AM","2:30AM","2:45AM","3:00AM","3:15AM","3:30AM","3:45AM","4:00AM","4:15AM","4:30AM","4:45AM","5:00AM","5:15AM","5:30AM","5:45AM","6:00AM","6:15AM","6:30AM","6:45AM","7:00AM","7:15AM","7:30AM","7:45AM","8:00AM","8:15AM","8:30AM","8:45AM","9:00AM","9:15AM","9:30AM","9:45AM","10:00AM","10:15AM","10:30AM","10:45AM","11:00AM","11:15AM","11:30AM","11:45AM","12:00PM","12:15PM","12:30PM","12:45PM","1:00PM","1:15PM","1:30PM","1:45PM","2:00PM","2:15PM","2:30PM","2:45PM","3:00PM","3:15PM","3:30PM","3:45PM","4:00PM","4:15PM","4:30PM","4:45PM","5:00PM","5:15PM","5:30PM","5:45PM","6:00PM","6:15PM","6:30PM","6:45PM","7:00PM","7:15PM","7:30PM","7:45PM","8:00PM","8:15PM","8:30PM","8:45PM","9:00PM","9:15PM","9:30PM","9:45PM","10:00PM","10:15PM","10:30PM","10:45PM","11:00PM","11:15PM","11:30PM", "11:45PM",];
export const times = ["12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM"];

export type AvailabilitiesCollection = {
    Binaries: AvailabitiesBinary,
    IsAny: AvailabilitiesIsAny
}

export type AvailabitiesBinary = {
    Monday: string,
    Tuesday: string,
    Wednesday: string,
    Thursday: string,
    Friday: string,
    Saturday: string,
    Sunday: string,
}

export type AvailabilitiesIsAny = {
    Monday: boolean,
    Tuesday: boolean,
    Wednesday: boolean,
    Thursday: boolean,
    Friday: boolean,
    Saturday: boolean,
    Sunday: boolean,
}

export function convertToBinary(number: number): string {
    if (number === undefined) {
        return "0".repeat(48);
    }
    return number.toString(2).padStart(48, "0");
}

export function convertToNumber(binary: string): number {
    if (binary === undefined) {
        return 0;
    }
    return parseInt(binary, 2);
}

export function getTimeSlotsFromNumber(number: number): string[] {
    if (number === undefined) {
        return [];
    }
    const binary = number.toString(2).padStart(48, "0");
    return getTimeSlotsFromBinary(binary);
}

export function getTimeSlotsFromBinary(binary: string): string[] {
    if (binary === undefined || binary.length !== 48) {
        return [];
    }
    const timeSlots: string[] = [];
    var startTime = 0;
    var endTime = 0;
    for (let i = 0; i < binary.length; i++) {
        if (binary[i] === "1") {
            startTime = i;
            while (i < binary.length && binary[i] === "1") {
                i++;
            }
            endTime = i;
            timeSlots.push(
                `${getTimeString(startTime)} - 
                ${getTimeString(endTime)}`
            );


        }
    }
    return timeSlots;
}

export function getTimeString(time: number): string {
    var hour = Math.floor(time / 2);
    var minute = (time % 2) * 30;
    return `${hour.toString(10).padStart(2, "0")}:${minute.toString(10).padStart(2, "0")}`;
}

export function convertScheduleToAvailbilityBinary(tutorSchedule: TutorScheduleNoTimeZone): AvailabitiesBinary {
    return {
        Monday: convertToBinary(tutorSchedule.Monday),
        Tuesday: convertToBinary(tutorSchedule.Tuesday),
        Wednesday: convertToBinary(tutorSchedule.Wednesday),
        Thursday: convertToBinary(tutorSchedule.Thursday),
        Friday: convertToBinary(tutorSchedule.Friday),
        Saturday: convertToBinary(tutorSchedule.Saturday),
        Sunday: convertToBinary(tutorSchedule.Sunday),
    } as AvailabitiesBinary;
}

export function getEmptyAvailabilityBinary(): AvailabitiesBinary {
    return {
        Monday: convertToBinary(0),
        Tuesday: convertToBinary(0),
        Wednesday: convertToBinary(0),
        Thursday: convertToBinary(0),
        Friday: convertToBinary(0),
        Saturday: convertToBinary(0),
        Sunday: convertToBinary(0),
    } as AvailabitiesBinary;
}

export function getUnselectedAvailabilityIsAny(): AvailabilitiesIsAny {
    return {
        Monday:false,
        Tuesday:false,
        Wednesday:false,
        Thursday:false,
        Friday:false,
        Saturday:false,
        Sunday:false,
    } as AvailabilitiesIsAny;
}

export function getAvailabilityFromNewBooking(newBooking: NewBookingSchema): AvailabitiesBinary {
    return {
        Monday: convertToBinary(newBooking.TimeSlotMonday),
        Tuesday: convertToBinary(newBooking.TimeSlotTuesday),
        Wednesday: convertToBinary(newBooking.TimeSlotWednesday),
        Thursday: convertToBinary(newBooking.TimeSlotThursday),
        Friday: convertToBinary(newBooking.TimeSlotFriday),
        Saturday: convertToBinary(newBooking.TimeSlotSaturday),
        Sunday: convertToBinary(newBooking.TimeSlotSunday),
    } as AvailabitiesBinary;
}

export function getAvailabilityFromAllNewBookings(newBooking: NewBookingSchema[]): AvailabitiesBinary {
    const availability = getEmptyAvailabilityBinary();
    newBooking.forEach((booking) => {
        availability.Monday = (parseInt(availability.Monday, 2) | booking.TimeSlotMonday).toString(2).padStart(48, "0");
        availability.Tuesday = (parseInt(availability.Tuesday, 2) | booking.TimeSlotTuesday).toString(2).padStart(48, "0");
        availability.Wednesday = (parseInt(availability.Wednesday, 2) | booking.TimeSlotWednesday).toString(2).padStart(48, "0");
        availability.Thursday = (parseInt(availability.Thursday, 2) | booking.TimeSlotThursday).toString(2).padStart(48, "0");
        availability.Friday = (parseInt(availability.Friday, 2) | booking.TimeSlotFriday).toString(2).padStart(48, "0");
        availability.Saturday = (parseInt(availability.Saturday, 2) | booking.TimeSlotSaturday).toString(2).padStart(48, "0");
        availability.Sunday = (parseInt(availability.Sunday, 2) | booking.TimeSlotSunday).toString(2).padStart(48, "0");
    });
    return availability;
}

export function parseBinaryToListOfTimeSlots(binary: string): string[] {
    var slots = [];
    var starter = -1;
    for (let i = 0; i < binary.length; i++) {
        if (starter === -1 && binary[i] === "1") {
            starter = i;
        } else {
            if (binary[i] === "0" && starter !== -1) {
                slots.push(timesHalfAnHour[starter] + " - " + timesHalfAnHour[i]);
                starter = -1;
            }
        }
    }
    if (starter !== -1) {
        slots.push(timesHalfAnHour[starter] + " - Midnight");
    }
    return slots;
}

export function setTimes(ac: AvailabilitiesCollection): string[][] {
    const times: string[][] = [];
    var a = ac.Binaries;
    var availabilitiesIsAny = ac.IsAny;

    if (a.Monday) {
        if (a.Monday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Monday === true) {
                times.push(["Any Available Time"]);
            } else {
                var m = parseBinaryToListOfTimeSlots(a.Monday);
                times.push(m);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Monday === false) {
            times.push([]);
        }
    }

    if (a.Tuesday) {
        if (a.Tuesday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Tuesday === true) {
                times.push(["Any Available Time"]);
            } else {
                var tue = parseBinaryToListOfTimeSlots(a.Tuesday);
                times.push(tue);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Tuesday === false) {
            times.push([]);
        }
    }

    if (a.Wednesday) {
        if (a.Wednesday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Wednesday === true) {
                times.push(["Any Available Time"]);
            } else {
                var wed = parseBinaryToListOfTimeSlots(a.Wednesday);
                times.push(wed);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Wednesday === false) {
            times.push([]);
        }
    }

    if (a.Thursday) {
        if (a.Thursday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Thursday === true) {
                times.push(["Any Available Time"]);
            } else {
                var thur = parseBinaryToListOfTimeSlots(a.Thursday);
                times.push(thur);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Thursday === false) {
            times.push([]);
        }
    }

    if (a.Friday) {
        if (a.Friday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Friday === true) {
                times.push(["Any Available Time"]);
            } else {
                var fri = parseBinaryToListOfTimeSlots(a.Friday);
                times.push(fri);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Friday === false) {
            times.push([]);
        }
    }

    if (a.Saturday) {
        if (a.Saturday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Saturday === true) {
                times.push(["Any Available Time"]);
            } else {
                var sat = parseBinaryToListOfTimeSlots(a.Saturday);
                times.push(sat);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Saturday === false) {
            times.push([]);
        }
    }

    if (a.Sunday) {
        if (a.Sunday.indexOf("1") > -1) {
            if (availabilitiesIsAny && availabilitiesIsAny.Sunday === true) {
                times.push(["Any Available Time"]);
            } else {
                var sun = parseBinaryToListOfTimeSlots(a.Sunday);
                times.push(sun);
            }
        } else if (availabilitiesIsAny && availabilitiesIsAny.Sunday === false) {
            times.push([]);
        }
    }

    return times;
}

export function setTimesFromBinaries(availability: AvailabitiesBinary): string[][] {
    const times: string[][] = [];

    if (availability.Monday) {
        if (availability.Monday.indexOf("1") > -1) {
            var m = parseBinaryToListOfTimeSlots(availability.Monday);
            times.push(m);
        } else {
            times.push([]);
        }
    }

    if (availability.Tuesday) {
        if (availability.Tuesday.indexOf("1") > -1) {
            var tue = parseBinaryToListOfTimeSlots(availability.Tuesday);
            times.push(tue);
        } else {
            times.push([]);
        }
    }

    if (availability.Wednesday) {
        if (availability.Wednesday.indexOf("1") > -1) {
            var wed = parseBinaryToListOfTimeSlots(availability.Wednesday);
            times.push(wed);
        } else {
            times.push([]);
        }
    }

    if (availability.Thursday) {
        if (availability.Thursday.indexOf("1") > -1) {
            var thur = parseBinaryToListOfTimeSlots(availability.Thursday);
            times.push(thur);
        } else {
            times.push([]);
        }
    }

    if (availability.Friday) {
        if (availability.Friday.indexOf("1") > -1) {
            var fri = parseBinaryToListOfTimeSlots(availability.Friday);
            times.push(fri);
        } else {
            times.push([]);
        }
    }

    if (availability.Saturday) {
        if (availability.Saturday.indexOf("1") > -1) {
            var sat = parseBinaryToListOfTimeSlots(availability.Saturday);
            times.push(sat);
        } else {
            times.push([]);
        }
    }

    if (availability.Sunday) {
        if (availability.Sunday.indexOf("1") > -1) {
            var sun = parseBinaryToListOfTimeSlots(availability.Sunday);
            times.push(sun);
        } else {
            times.push([]);
        }
    }

    return times;
}

export function getDurationText(duration: number) {
    if (duration < 0) { return "" }
    var hourly = duration * 0.5;
    return hourly + " Hours";

}

export function getTimeSlotFromIndex(index: number): string {
    if (index < 0) { return ""}
    
    return get15minuteIntervals[index];
}

export function getTimeSlotFromAndTo(index: number,duration: number): string {
    if (index < 0) { return "" }
    var toIndex = index + (duration * 2);
    var toTime = "";
    if (toIndex >= get15minuteIntervals.length) {
        if (toIndex === get15minuteIntervals.length) {
            toTime = "12:00PM";
        } else {
            toTime = get15minuteIntervals[toIndex - get15minuteIntervals.length]
        }
    } else {
        toTime = get15minuteIntervals[index + (duration * 2)];
    }
    return get15minuteIntervals[index] + " - " + toTime ;
}

export function getTimesItemPairHalfHour() {
    var items: ItemPair[] = [];
    timesHalfAnHour.forEach((v, i) => {
        items.push({ Text: v, Value: i + "" });
    });
    return items;
}